import React from 'react';
import { Modal} from 'hyperdb-utils';
import { ConfirmModal } from 'hyperdb-utils';
import PriceMinNightsForm from './PriceMinNightsForm';

class PriceMinNights extends React.Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDeletePriceMinNights = this.handleDeletePriceMinNights.bind(this);
    this.state = {};
  }
  render() {
    const props = this.props;
    return (
      <fieldset>
        <legend>
          Variations for min. nights
          &nbsp;
          <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModal.bind(this, true, -1) }>New</button>
        </legend>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>Min. nights</th>
                <th>Variation (%)</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                (props.prices || []).map((params, i) => {
                  return (
                    <tr key={ i }>
                      <td>{ params.min_nights }</td>
                      <td>{ params.value }</td>
                      <td>
                        <button type="button" className="btn btn-xs btn-default" onClick={ this.handleToggleModal.bind(this, true, i) }>
                          Edit
                        </button>
                        &nbsp;
                        <button type="button" className="btn btn-xs btn-danger" onClick={ this.handleToggleModalDelete.bind(this, i) }>
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.state.showModalPriceMinNightsForm
            ? <Modal title="Variation for min. nights" onClose={ this.handleToggleModal.bind(this, false)} onAccept={ this.handleSave }>
                <PriceMinNightsForm
                  params={ this.state.editedPriceMinNights }
                  onChange={ this.handleChange }
                />
              </Modal>
            : null
        }
        {
          this.state.showModalDeletePriceMinNights
            ? <ConfirmModal title="Delete price" onClose={ this.handleToggleModalDelete.bind(this, -1)} onConfirm={ this.handleDeletePriceMinNights }>
                Delete this price ?
              </ConfirmModal>
            : null
        }
      </fieldset>
    );
  }

  hasPPNG(price) {
    return (price.prices_for_nb_guests || []).length > 0;
  }

  handleToggleModal(bool, indexEditedPriceMinNights = -1) {
    const editedPriceMinNights = bool && indexEditedPriceMinNights !== -1
      ? { ...this.props.prices[indexEditedPriceMinNights] }
      : { value: 100 };
    this.setState({ showModalPriceMinNightsForm: bool, indexEditedPriceMinNights, editedPriceMinNights });
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    const editedPriceMinNights = { ...this.state.editedPriceMinNights, [attributeName]: value };
    this.setState({ editedPriceMinNights });
  }
  handleSave() {
    const prices = (this.props.prices || []).slice();
    const index = this.state.indexEditedPriceMinNights;
    const params = this.state.editedPriceMinNights;
    if (params.min_nights) {
      if (index === -1) {
        prices.push(params);
      } else {
        prices[index] = params;
      }
      this.props.onChange({ value: prices });
      this.handleToggleModal(false);
    }
  }
  handleToggleModalDelete(indexDeletePriceMinNights = -1) {
    const showModalDeletePriceMinNights = indexDeletePriceMinNights !== -1;
    this.setState({ showModalDeletePriceMinNights, indexDeletePriceMinNights });
  }
  handleDeletePriceMinNights() {
    const index = this.state.indexDeletePriceMinNights;
    if (index !== -1) {
      const prices = (this.props.prices || []).slice();
      prices.splice(index, 1);
      this.props.onChange({ value: prices });
      this.handleToggleModalDelete(-1);
    }
  }
};

export default PriceMinNights;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/PriceMinNights.jsx